import { BookOpenCheckIcon, FileTextIcon, FolderOpenIcon, LightbulbIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Mining & Mineral Resources Classroom Activities & Challenges',
    description:
      '150 ready-to-use activity ideas covering mining fundamentals, minerals and geology, exploration and evaluation, surface mining, underground mining, mineral processing, mine safety, environmental management, sustainability, and critical thinking scenarios. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Mining & Mineral Resources Assessment Bank',
    description:
      'Comprehensive assessment resources designed to evaluate student learning throughout a mining and mineral resources course. Includes:',
    items: [
      'Short-answer questions',
      'Concept explanations',
      'Compare-and-contrast tasks',
      'Scenarios and decision-making',
      'Evidence interpretation',
      'Cause-and-effect exercises',
      'Misconception correction',
      'Extended responses',
      'Reflection activities',
      'Suggested answers and key concepts',
      'Teacher evaluation guidance',
    ],
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ListChecksIcon,
  },
  {
    number: '03',
    title: '100 Mining Case Studies & Real-World Scenarios',
    description:
      'A collection of 100 developed mining cases involving mineral deposits and geology, exploration and resource evaluation, mining methods and operations, mineral processing, mine safety, environmental management, mining economics, and sustainability considerations.',
    benefit:
      'Students analyze evidence, answer guiding questions, evaluate situations, justify ideas, and think critically.',
    value: 'USD 14',
    icon: FileTextIcon,
  },
  {
    number: '04',
    title: '50 Mining & Mineral Resources Classroom Projects & Inquiry Challenges',
    description:
      '50 structured classroom projects that encourage students to investigate mining topics, analyze problems, develop understanding, make recommendations, and communicate their learning through practical classroom work. Each includes objectives, background information, student challenges, instructions, guiding questions, and assessment criteria.',
    benefit: 'Your students finish the year with real mining learning projects.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
  {
    number: '05',
    title: "Mining & Mineral Resources Teacher's Concept & Terminology Guide",
    description:
      'Comprehensive reference handbook covering essential Mining and Mineral Resources terminology and concepts. Designed to help teachers and students quickly review vocabulary related to geology and minerals, mining methods, ore processing, mine safety, environmental management, and mining in society.',
    benefit: 'Project it in class and your students instantly understand complex mining concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
    wide: true,
  },
];
